import { render, staticRenderFns } from "./NotificacionAportesResponse.vue?vue&type=template&id=ed92f1b8&scoped=true"
import script from "./NotificacionAportesResponse.vue?vue&type=script&lang=ts"
export * from "./NotificacionAportesResponse.vue?vue&type=script&lang=ts"
import style0 from "./NotificacionAportesResponse.vue?vue&type=style&index=0&id=ed92f1b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed92f1b8",
  null
  
)

export default component.exports